import { NoSymbolIcon, XMarkIcon } from '@heroicons/react/24/outline'
import type { Application, RejectReason, RejectReasonCode } from '../../types'
import { rejectOptions } from '../../utils'

type Props = {
  app: Application | null
  rejectState: RejectReason
  onRejectStateChange: (reason: RejectReason) => void
  onCancel: () => void
  onSubmit: (appId: string, reason: RejectReason) => void
}

export const RejectModal = ({
  app,
  rejectState,
  onRejectStateChange,
  onCancel,
  onSubmit,
}: Props) => {
  if (!app || app.archived || app.status === 'rejected') return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
      <div className="w-full max-w-md border border-app-line bg-app-surface p-4 space-y-4 rounded-2xl shadow-app-card">
        <div className="flex items-center justify-between">
          <p className="text-sm font-semibold text-app-ink flex items-center gap-2">
            <NoSymbolIcon className="h-4 w-4 text-rose-700 dark:text-rose-400" aria-hidden="true" />
            Reject: {app.company}
          </p>
          <button
            onClick={onCancel}
            className="text-app-muted hover:text-app-ink"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-3">
          <div className="space-y-1">
            <label className="text-xs uppercase text-app-muted font-medium">Reason</label>
            <select
              value={rejectState.code}
              onChange={(e) =>
                onRejectStateChange({ ...rejectState, code: e.target.value as RejectReasonCode })
              }
              className="w-full rounded-lg border border-app-line bg-app-surface px-3 py-2 text-sm text-app-ink focus:border-app-accent focus:outline-none"
            >
              {rejectOptions.map((opt) => (
                <option key={opt.code} value={opt.code}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div className="space-y-1">
            <label className="text-xs uppercase text-app-muted font-medium">Details (optional)</label>
            <input
              type="text"
              placeholder="Additional context..."
              value={rejectState.details ?? ''}
              onChange={(e) => onRejectStateChange({ ...rejectState, details: e.target.value })}
              className="w-full rounded-lg border border-app-line bg-app-surface px-3 py-2 text-sm text-app-ink focus:border-app-accent focus:outline-none"
            />
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-2">
          <button
            onClick={onCancel}
            className="rounded-lg border border-app-line px-4 py-2 text-sm font-semibold text-app-ink hover:bg-app-subtle"
          >
            Cancel
          </button>
          <button
            onClick={() => onSubmit(app.id, rejectState)}
            className="rounded-lg bg-rose-600 px-4 py-2 text-sm font-semibold text-white hover:bg-rose-700"
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  )
}

